(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){

module.exports = {
		initCircleProductsCarousel: function () {
		if($('.circle_products-cards-wrapper.swiper').length){
			const swiper = new Swiper('.circle_products-cards-wrapper', {
				direction: 'horizontal',
				loop: false,
				slidesPerView: 3,
				slidesPerGroup: 3,
				spaceBetween: 16,
				grabCursor: true,
				speed: 600,
				breakpoints: {
					640: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 16,
						navigation: {
							enabled: true,
						    nextEl: '.swiper-button-next',
						    prevEl: '.swiper-button-prev',
						},
					},
					 320: {
				      slidesPerView: 1.05,
					  slidesPerGroup: 1,
				      spaceBetween: 16,
					  navigation: {
							enabled: false,
						    nextEl: '.swiper-button-next',
						    prevEl: '.swiper-button-prev',
						},
				    },
					
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				
			});
		}
		
		
	}
};
},{}],2:[function(require,module,exports){
module.exports = {
	initFAQ: function () {

		$('.faq-item').on('click', function(){
			$(this).toggleClass('active');
			$(this).children('.faq-answer').slideToggle(300);
		});
	}
}
},{}],3:[function(require,module,exports){

module.exports = {
		initNewsCarousel: function () {
		const swiper = new Swiper('.news-wrapper', {
			direction: 'horizontal',
			loop: false,
			slidesPerView: 3,
			slidesPerGroup: 3,
			spaceBetween: 16,
			grabCursor: true,
			speed: 600,
			breakpoints: {
				640: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 16,
					navigation: {
						enabled: true,
					    nextEl: '.swiper-button-next',
					    prevEl: '.swiper-button-prev',
					},
				},
				 320: {
			      slidesPerView: 1,
				  slidesPerGroup: 1,
			      spaceBetween: 16,
				  navigation: {
						enabled: false,
					    nextEl: '.swiper-button-next',
					    prevEl: '.swiper-button-prev',
					},
			    },
				
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			
		});
	}
};
},{}],4:[function(require,module,exports){

module.exports = {
	filterNews: function() {
		var $newsNavigation = $('#news-categories');
		var currentCategory = '';
		
		$('a',$newsNavigation).on('click', function(e){
			e.preventDefault();
			currentCategory = $(this).data('post_type');
			
			console.log(currentCategory);
			
			$('a', $newsNavigation).removeClass('active');
			$(this).addClass('active');
			
			$('.news-item').fadeOut();
			
			setTimeout(function(){
				if(currentCategory == 'all'){
					$('.news-item').fadeIn();
				} else {
					$('.news-item[data-post_type="'+currentCategory+'"').fadeIn();	
				}
			}, 300);
			
		});
		
	}, 
	
};

},{}],5:[function(require,module,exports){

module.exports = {
		initRetailersCarousel: function () {
		if($('.retailers-cards-wrapper.swiper').length){
			const swiper = new Swiper('.retailers-cards-wrapper', {
				direction: 'horizontal',
				loop: false,
				slidesPerView: 3,
				slidesPerGroup: 3,
				spaceBetween: 16,
				grabCursor: true,
				speed: 600,
				breakpoints: {
					640: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 16,
						navigation: {
							enabled: true,
						    nextEl: '.swiper-button-next',
						    prevEl: '.swiper-button-prev',
						},
					},
					 320: {
				      slidesPerView: 1.05,
					  slidesPerGroup: 1,
				      spaceBetween: 16,
					  navigation: {
							enabled: false,
						    nextEl: '.swiper-button-next',
						    prevEl: '.swiper-button-prev',
						},
				    },
					
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				
			});
		}
		
		
	}
};
},{}],6:[function(require,module,exports){

module.exports = {
	hideMobileNav: function() {
		if (myVars.isNavActive == true) {
			myVars.isNavActive = false;
			$('body').removeClass('navigation-open');
			$('#mobile-navigation').removeClass('active');
			$('.mobile-menu-icon').removeClass('is-active');
			$('#main-header-scroll').removeClass('show-nav').addClass('hide-nav');
			$('#mobile-navigation').addClass('active').css('padding-top', myVars.navbarHeight + 'px');
			
			gsap.to('#mobile-navigation', {
				duration:.6,
				y: -100,
				autoAlpha: 0,
				ease: Power4.easeOut
			});
			
		}
	
	}, 
	
	showMobileNav: function() {
			if (myVars.isNavActive == false) {
				myVars.isNavActive = true;
				$('body').addClass('navigation-open');
				$('.mobile-menu-icon').addClass('is-active');
				$('#mobile-navigation').addClass('active').css('padding-top', myVars.navbarHeight + 'px');
				
				
				var tlMobileNavigation = gsap.timeline();
	
				tlMobileNavigation.to('#mobile-navigation', {
					duration:.6,
					y: 0,
					autoAlpha: 1,
					ease: Power4.easeOut
				});
				tlMobileNavigation.from('#mobile-navigation .menu li, #mobile-navigation .header-btn-wrapper, .mobile-navigation-footer .footer-email, .mobile-navigation-footer .footer-address, .mobile-navigation-footer .copyright,  .mobile-navigation-footer .footer-social', {
					duration:.6,
					y: 100,
					autoAlpha: 0,
					stagger: .1,
					ease: Power4.easeOut
				},'-=.6');
				
				
				
				//console.log(isNavActive);
			} else {
				this.hideMobileNav();
			}
	}, 
	
	animateNavigation: function() {
		var tlNavigation = gsap.timeline({
			delay: .3
			
		});
		tlNavigation.to('#main-logo',  {
			duration: .6,
			y: 0,
			autoAlpha: 1,
			ease: Power4.easeOut
		});
		tlNavigation.to('#main-navigation li a,.header-btn-wrapper',  {
			duration: .6,
			y: 0,
			autoAlpha: 1,
			stagger: .1,
			ease: Power4.easeOut
		},
		'-=.3');
	},
	
	showHeader: function() {
		$('#main-header-scroll').removeClass('hide-nav').addClass('show-nav');
	},
	
	autoHideHeader: function() {
		//console.log(windowWidth);
		myVars.currentTop = $(window).scrollTop();
		
			if( myVars.currentTop > 150){
				if (myVars.previousTop - myVars.currentTop > myVars.scrollDelta) {
		 			//if scrolling up...
		 			$('#main-header-scroll').removeClass('hide-nav').addClass('show-nav');
				} else if (myVars.currentTop - myVars.previousTop > myVars.scrollDelta && myVars.currentTop > myVars.scrollOffset) {
		 			//if scrolling down...
		 			$('#main-header-scroll').removeClass('show-nav').addClass('hide-nav');
				}
				
			} else {
				$('#main-header-scroll').removeClass('show-nav').addClass('hide-nav');
			}
			
			myVars.previousTop = myVars.currentTop;
			myVars.scrolling = false;
			
		
	}

};

},{}],7:[function(require,module,exports){
module.exports = {
	subscribeToMailchimp: function () {
		$('.mc-embedded-subscribe-form').submit(function(e) {
			e.preventDefault(); // Prevents the default form submission action
			
			var postData = $(this).serialize(); // Serializes form data
	        var formURL = $(this).attr('action').replace('/post?', '/post-json?') + '&c=?'; // Changes the action URL to return JSON
			
			        $.ajax({
				type: 'GET',
				url: formURL,
				data: postData,
				cache: false,
				dataType: 'jsonp',
				// JSONP to avoid cross-origin issues
	            jsonp: 'c',
				// Callback parameter for JSONP
	            contentType: "application/json; charset=utf-8",
				error: function (error) { 
	                // Error handling
				},
					success: function (data) {
					if (data.result != "success") {
						 var erroMessage = data.msg;
						 erroMessage = erroMessage.substring(erroMessage.indexOf("-") + 1);
	                     $('#mce-error-response').html(erroMessage).fadeIn();
					} else {
						console.log(data.result)
						$('#mce-error-response').hide();
	                    $('#mce-success-response').fadeIn();
						setTimeout(function(){
							$('#mce-success-response').fadeOut();
							$('#mc-embedded-subscribe-form')[0].reset();
						}, 2000);
					}
				}
			});
		});
	}
}

},{}],8:[function(require,module,exports){
module.exports = {
	

	initPageAnimations: function() {
		
		gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);

	/** Basic Reveal Animation */	
		document.fonts.ready.then(function () {
			
			var theStart = "top bottom";
			
			if( myVars.windowWidth > 640){
				theStart = "top bottom";
			}
			
			
			
			/* Animate Thumbnails */
			
			gsap.utils.toArray(".animation-thumbnails").forEach(reveal => {
			  
			  var tl = gsap.timeline({
			    scrollTrigger: {
			      trigger: reveal,
				  start: "top bottom",
				  toggleActions: "play none none reverse",
			      markers: false
			    }
			  });
			
			  tl.to(reveal, {
			    duration: 1,
				height: 0,
				ease: "power4"
			  });
			  
			});
		
		gsap.utils.toArray(".animation-hero_image").forEach(reveal => {
			  
			  var tl = gsap.timeline({
			    scrollTrigger: {
			      trigger: reveal,
				  start: "top bottom",
				  toggleActions: "play none none reverse",
			      markers: false
			    }
			  });
			
			  tl.to(reveal, {
			    duration: 1,
				height: 0,
				ease: "power4",
				delay: .3
			  });
			  
			});
			
			/* Animate UI Elements */
			
			gsap.utils.toArray(".animation-reveal").forEach(reveal => {
			  
			  var tl = gsap.timeline({
			    scrollTrigger: {
			      trigger: reveal,
				  start: "-320 bottom",
				  toggleActions: "play none none reverse",
			      markers: false
			    }
			  });
			
			  tl.to(reveal, {
			    duration: 1,
				y: 0,
			    autoAlpha: 1,
				ease: "power4",
			  });
			  
			});
			
		
						
			gsap.utils.toArray(".animation-stagger").forEach(stagger => {
			  
			  var tlStagger = gsap.timeline({
			    scrollTrigger: {
			      trigger: stagger,
				  start: "-320 bottom",
				  toggleActions: "play none none reverse",
			      markers: false
			    }
			  });
			
			  tlStagger.to($('.animated',stagger), {
			    duration: 1,
				y: 0,
			    autoAlpha: 1,
				ease: "power4",
				stagger: 0.1
			  });
			  
			});
			
			
		});
		
	}, 
	
	killAllScrollTrigger: function() {
		let Alltrigger = ScrollTrigger.getAll()
			for (let i = 0; i < Alltrigger.length; i++) {
			Alltrigger[i].kill(true)
		}
	},
	
	
	initParallax: function() {
		
		var $parallaxElements = $('.parallax');
	
	
		gsap.utils.toArray(".parallax").forEach(reveal => {
			  
			  let speed = reveal.getAttribute('data-parallax-speed');
			  
			  var tl = gsap.timeline({
			    scrollTrigger: {
			      trigger: reveal,
				  start: "top bottom", // When the top of the element hits the bottom of the viewport
	                end: "bottom top", // When the bottom of the element exits the top of the viewport
	                scrub: true // Smooth scrubbing, true to tie it directly to scroll position
			    }
			  });
			
			  tl.to(reveal, {
			    yPercent: -parseFloat(speed) * 60,
	            ease: "none",
			  });
			  
			});
	
	
	    // Initialize parallax for each element
	   	}
	
	
	

};
},{}],9:[function(require,module,exports){

module.exports = {
	initTeamCarousel: function () {
		const swiper = new Swiper('.team-founders .team-wrapper', {
			direction: 'horizontal',
			loop: false,
			slidesPerView: 3,
			spaceBetween: 10,
			grabCursor: true,
			speed: 600,
			breakpoints: {
				640: {
					slidesPerView: 3,
					spaceBetween: 16,
					navigation: {
						enabled: true,
					    nextEl: '.swiper-button-next',
					    prevEl: '.swiper-button-prev',
					},
				},
				 320: {
			      slidesPerView: 1,
			      spaceBetween: 16,
				  navigation: {
						enabled: false,
					    nextEl: '.swiper-button-next',
					    prevEl: '.swiper-button-prev',
					},
			    },
				
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			
		});
	},
	initCardsCarousel: function () {
		const swiper = new Swiper('.circle-cards-wrapper.swiper', {
			direction: 'horizontal',
			loop: false,
			slidesPerView: 'auto',
			spaceBetween: 16,
			grabCursor: true,
			speed: 600,
			breakpoints: {
				1140: {
					slidesPerView: 'auto',
					spaceBetween: 16,
					navigation: {
						enabled: true,
					    nextEl: '.swiper-button-next',
					    prevEl: '.swiper-button-prev',
					},
				},
				800: {
					slidesPerView: 'auto',
					spaceBetween: 16,
					navigation: {
						enabled: true,
					    nextEl: '.swiper-button-next',
					    prevEl: '.swiper-button-prev',
					},
				},
				 320: {
			      slidesPerView: 'auto',
			      spaceBetween: 16,
				  navigation: {
						enabled: false,
					    nextEl: '.swiper-button-next',
					    prevEl: '.swiper-button-prev',
					},
			    },
				
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			
		});
	}
};
},{}],10:[function(require,module,exports){
var vars = require('./vars.js');
var navigation = require('../../../partials/navigation/main/navigation.js');
var newsletter = require('../../../partials/newsletter/newsletter.js');
var animations = require('./animations.js');
var carousel = require('./carousel.js');
var news_grid = require('../../../partials/blocks/news-grid/news-grid.js');
var news_carousel = require('../../../partials/blocks/news-carousel/news-carousel.js');
var retailers = require('../../../partials/blocks/retailers/retailers.js');
var circle_products = require('../../../partials/blocks/circle-products/circle-products.js');
var faq = require('../../../partials/blocks/faq/faq.js');



jQuery(document).ready(function( $ ) {
	
	gsap.registerPlugin(ScrollTrigger,ScrollToPlugin);

	$(window).on('resize', function() {
		
		
		myVars.windowWidth = window.innerWidth;
		
		if( myVars.windowWidth > 536){
			myVars.navbarHeight = $('#main-header').outerHeight();
			//$('.page-wrapper').css('padding-top', myVars.navbarHeight + 'px');
			navigation.hideMobileNav();
			
		} 		
	});
	
	$(window).on('scroll', function() {
		if (!myVars.scrolling) {
			myVars.scrolling = true;
			(!window.requestAnimationFrame)
				? setTimeout(navigation.autoHideHeader, 250)
				: requestAnimationFrame(navigation.autoHideHeader);
		}
	});


/* Lazy Load */
	
	var myLazyLoad = new LazyLoad({
		elements_selector: ".lazyload",
		callback_loaded: (el)=>{initOneLazyLoad(el)}
	
	});
	
	function initOneLazyLoad(el){
		//console.log("Loaded", el)
	}
	
/* Init */

	function init(container){
	  	
	  	$(window).scrollTop(0);
	  	navigation.hideMobileNav();
		animations.initPageAnimations();
		
		newsletter.subscribeToMailchimp();
		myLazyLoad.update();
//		navigation.showHeader();
		initFancybox();
//		barba.initBarba();
		addCurrentMenuClass();
		carousel.initTeamCarousel();
		news_carousel.initNewsCarousel();
		news_grid.filterNews();
		carousel.initCardsCarousel();
		circle_products.initCircleProductsCarousel();
		retailers.initRetailersCarousel();
		//$('.page-wrapper').css('padding-top', myVars.navbarHeight + 'px');
		animations.initParallax();
		checkNavigationStyle(container);
		initFormLabel();
		faq.initFAQ();
		initProductInfo();
		//checkJobPage();
	}

	init();
	
	
	function initProductInfo(){
		$('.info-item').on('click', function(){
			if ($(this).hasClass('active')){
				$(this).removeClass('active');
				$(this).children('.info-content').slideUp();
			} else {
				$('.info-item .info-content').slideUp();
				$('.info-item').removeClass('active');
				$(this).toggleClass('active');
				$(this).children('.info-content').slideToggle(300);
				
				}
		});
		
	}
	
	
	function checkJobPage(){
		
		 
		 if ($('#section-jobs').length > 0) {
		    var categories = $('#section-jobs').data('categories');
		    
		    // Check if categories is empty or just contains whitespace
		    if (categories && categories.trim().length > 0) {
		        // Convert the string into an array by splitting at commas
		        var categoriesArray = categories.split(',').map(function(item) {
		            return item.trim().toLowerCase();  // Remove extra spaces and ensure lowercase matching
		        });
		
		        loadOpenJobRequisitions(categoriesArray);
		    } else {
		        // Optionally handle the case where no categories are provided
		        loadOpenJobRequisitions([]);
		    }
		}

	};

	
	
	
	
	function initFancybox(){
		Fancybox.bind("[data-fancybox], .woocommerce-product-gallery a", {
		});
	}
		
	$('.mobile-menu-icon').on('click', function(e) {
		e.preventDefault();
		navigation.showMobileNav();
	});
	
	
	
	
	function checkNavigationStyle(container){
		var sectionHero = $('.section-hero', container);
		
		if(sectionHero.length){
			$('#main-header').removeClass('nav-color').addClass('nav-white');
		} else {
			$('#main-header').removeClass('nav-white').addClass('nav-color');
			$('.section:first', container).addClass('extra-padding');
			
		}
	}
	
	
	function addCurrentMenuClass(){
	
		var url = $(location).attr('href').replace(/\/+$/,''),
		parts = url.split("/"),
		last_part_url = parts[parts.length-1];
		
		
		$("#main-navigation .menu li a").removeClass('current');
		$("#main-navigation .menu li a").each(function( index ) {
		  
		  var link_url = $(this).attr('href').replace(/\/+$/,'').split("/");
		  var link_url_last_part = link_url[link_url.length-1];
		  if(last_part_url == link_url_last_part) {
			$(this).addClass('current');
			
			if ($(this).parents('.sub-menu').length) {
				$(this).parents('.sub-menu').prevAll('a').first().addClass('current');
			};
		  }
		  
		});
	
	}
	
	barba.init({
	cacheIgnore: true,
	timeout: 6000,
	sync: false,
	prevent: ({ href }) => {
		return href.includes('/product') || href.includes('/single-product') || href.includes('/merch') || href.includes('/shop') || href.includes('/cart') || href.includes('/checkout');
	},
	views: [
				{
					namespace: 'home',
					async beforeEnter(data) {
						
					}
				},
				{
					namespace: 'contact',
					async beforeEnter(data) {
						initFormLabel();
					}
				},
				{
					namespace: 'our-team',
					async beforeEnter(data) {
						carousel.initTeamCarousel();
						
					}
				},
				{
					namespace: 'join-circle',
					async beforeEnter(data) {
						carousel.initCarousel();
						
					}
				},
				{
					namespace: 'about',
					async beforeEnter(data) {
						
					}
				}				

				
			],
	transitions: [
			{
				// Add prevent logic here
			
				
				async leave(data) {
					var done = this.async();
					gsap.to(data.current.container,
					{
						duration: 0.4,
						autoAlpha: 0,
						y:  -150,
						ease: Power4.easeIn,
						force3D:true,
						onComplete: done
					});
					
					
					
				},
				async once(data) {
					navigation.animateNavigation();
					gsap.to(data.next.container,
					{
						duration: 2,
						autoAlpha: 1,
						y: 0,
						force3D:true,
						ease: Power4.easeOut
					});	
		
					scrollToAnchor();
					
				},
				async beforeLeave(data) {
					
				},
				
				async afterEnter(data) {
					
					scrollToAnchor();
					
					reinitForm();
					
					
				},
				async enter(data) {
					gsap.to(data.next.container,
					{
						duration: 1,
						autoAlpha: 1,
						y: 0,
						force3D:true,
						ease: Power4.easeOut
					});
				},
				async beforeEnter(data) {
				  	init(data.next.container);
				},
			}
			
		]
		
});

function scrollToAnchor(){
		const hash = window.location.hash;
        if (hash) {
          const anchor = document.querySelector(hash);
          if (anchor) {
			setTimeout(function(){
				
				anchor.scrollIntoView({ behavior: 'smooth' });
				}, 200)
            
          }
        }
}

function initFormLabel(){
	
		
		
		$('.wpcf7-form .wpcf7-form-control').on('focus blur', function(e) {
			
			var $label = $(this).parent().parent().find('.form-label');

		    if (e.type === 'focus' || $(this).val()) {
		        $label.addClass('active');
		    } else {
		        $label.removeClass('active');
		    }
	    });
	
	
}

barba.hooks.afterEnter((data) => {
	
	var vids = document.querySelectorAll("video");
	vids.forEach(vid => {
		var playPromise = vid.play();
		if (playPromise !== undefined) {
			playPromise.then(_ => {}).catch (error => {});
		};
	});
	
	 setTimeout(function() {
		checkJobPage();
	}, 10);


});




barba.hooks.afterLeave((data) => {
  
 
  // Set <body> classes for "next" page
	  var nextHtml = data.next.html;
	  var response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml);
	  var bodyClasses = $(response).filter('notbody').attr('class');
	  $("body").attr("class", bodyClasses);
	  $("body").addClass(displayMode);

	});

function reinitForm(){
	if (window.wpcf7) {
		document.querySelectorAll('.wpcf7-form').forEach(form => {
			wpcf7.init(form);
		});
	}
}

	


});


},{"../../../partials/blocks/circle-products/circle-products.js":1,"../../../partials/blocks/faq/faq.js":2,"../../../partials/blocks/news-carousel/news-carousel.js":3,"../../../partials/blocks/news-grid/news-grid.js":4,"../../../partials/blocks/retailers/retailers.js":5,"../../../partials/navigation/main/navigation.js":6,"../../../partials/newsletter/newsletter.js":7,"./animations.js":8,"./carousel.js":9,"./vars.js":11}],11:[function(require,module,exports){

	window.myVars = {
		scrolling : false,
		previousTop : 0,
		currentTop : 0,
		scrollDelta : 10,
		scrollOffset : 100,
		navbarHeight : $('#main-header').outerHeight(),
		isNavActive : false,
		windowWidth : window.innerWidth,
		currentTop:'',
		fontLoaded : false,
		isMobile : false,
	};	
		
		
},{}]},{},[10]);
